import React, { useState, lazy, Suspense } from 'react';

// Comps
import AccountSectionLayout from '@project-stories/ecommerce/Account/AccountSectionLayout';
import AccountOrders from '@project-stories/ecommerce/Account/AccountOrders/AccountOrders';
const AccountOrder = lazy(() => import('@project-stories/ecommerce/Account/AccountOrders/AccountOrder'));

// Types
import type { Order, Locales, Settings } from './types';

// Styles
import './account-orders.scss';

interface AccountOrdersLandingProps {
  orders: Order[];
  locales: Locales;
  settings: Settings;
}

const AccountOrdersLanding: React.FC<AccountOrdersLandingProps> = ({ orders, locales, settings }) => {
  const [activeOrder, setActiveOrder] = useState<Order | null>(null);

  const handleClickOrder = (event: React.ClickEvent<HTMLLinkElement>, order: Order) => {
    event.preventDefault();
    setActiveOrder(order);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <AccountSectionLayout classes={`flex w-full overflow-y-auto`}>
      <div className={'pb-3 overflow-x-auto w-full'}>
        {activeOrder ? (
          <Suspense>
            <AccountOrder
              order={activeOrder}
              onClickClose={() => setActiveOrder(null)}
              locales={locales.order}
              settings={settings}
            />
          </Suspense>
        ) : (
          <AccountOrders
            orders={orders}
            onClickOrder={handleClickOrder}
            locales={locales.orders}
            settings={settings}
          />
        )}
      </div>
    </AccountSectionLayout>
  );
};

export default AccountOrdersLanding;
